// extracted by mini-css-extract-plugin
module.exports = {"pText":"Text_pText__wZdsf","inlineDisplay":"Text_inlineDisplay__20BQj"};